import { useEffect, useState } from "react";
import { API, store } from "../lib/util";

const deviceId = () => {
  let d = store.get("device", null);
  if (!d) { d = "d-" + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)); store.set("device", d); }
  return d;
};
export const fmtAvg = a => a.toFixed(1).replace(".", ",");

export function StarsShown({ avg, count, testid }) {
  return (
    <span className="rshown" data-testid={testid} aria-label={`${fmtAvg(avg)} ud af 5 stjerner, ${count} bedømmelser`}>
      <span className="rst" style={{ "--p": `${(avg / 5) * 100}%` }} aria-hidden="true">★★★★★</span>
      <b>{fmtAvg(avg)}</b> <small>({count} bedømmelser)</small>
    </span>
  );
}

export function RateBox({ slug, initial, onChange, tp = "" }) {
  const [sum, setSum] = useState(initial);
  const [mine, setMine] = useState(() => store.get("ratings", {})[slug] || 0);
  const [hover, setHover] = useState(0);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetch(`${API}/recipes/${slug}/rating?device=${deviceId()}`).then(r => (r.ok ? r.json() : null)).then(d => {
      if (!d) return;
      setSum(d);
      if (d.mine) setMine(d.mine);
    }).catch(() => {});
  }, [slug]);
  const vote = async s => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await fetch(`${API}/recipes/${slug}/rating`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ stars: s, device: deviceId() }) });
      const d = await res.json();
      if (!res.ok) { setMsg(res.status === 429 ? "Prøv igen senere" : d.detail || "Noget gik galt. Prøv igen."); return; }
      setMine(s); setSum(d); setMsg("Tak for din bedømmelse");
      store.set("ratings", { ...store.get("ratings", {}), [slug]: s });
      onChange?.(d);
    } catch (e) { setMsg("Noget gik galt. Prøv igen."); }
    finally { setBusy(false); }
  };
  const lit = hover || mine;
  return (
    <section className="ratebox noprint" data-testid={`${tp}rating-box`}>
      <h2>Bedøm opskriften</h2>
      {sum?.shown && <p className="ravg"><StarsShown avg={sum.avg} count={sum.count} testid={`${tp}rating-average`} /></p>}
      <div className="rstars" role="radiogroup" aria-label="Bedøm opskriften fra 1 til 5 stjerner" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map(s => (
          <button key={s} type="button" role="radio" aria-checked={mine === s} aria-label={`${s} ${s === 1 ? "stjerne" : "stjerner"}`}
            className={s <= lit ? "on" : undefined} onMouseEnter={() => setHover(s)} onFocus={() => setHover(s)} onBlur={() => setHover(0)}
            onClick={() => vote(s)} disabled={busy} data-testid={`${tp}rating-star-${s}`}>★</button>
        ))}
      </div>
      <p className="rmsg" aria-live="polite" data-testid={`${tp}rating-message`}>{msg || (mine ? `Din bedømmelse: ${mine} ud af 5` : "Klik på en stjerne for at give din bedømmelse.")}</p>
    </section>
  );
}

export function NutritionBox({ n }) {
  if (!n) return null;
  const rows = [["Energi", `${n.kcal} kcal`, "kcal"], ["Protein", `${n.protein} g`, "protein"], ["Fedt", `${n.fat} g`, "fat"], ["Kulhydrat", `${n.carbs} g`, "carbs"]];
  return (
    <div className="nutri" data-testid="nutrition-box">
      <h3>Næring pr. portion (ca.)</h3>
      <dl>{rows.map(([l, v, k]) => <div key={k}><dt>{l}</dt><dd data-testid={`nutrition-${k}`}>{v}</dd></div>)}</dl>
      <p data-testid="nutrition-note">Næringsindholdet er et skøn beregnet ud fra ingredienserne.</p>
    </div>
  );
}
